module.exports = __webpack_public_path__ + "ae4ee97bf97a1c30519564ef56226712.png";